import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Heart, Search, User } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";
import { useWishlist } from "@/context/WishlistContext";
import { ext } from "@/lib/ext";

const Header = () => {
  const { lang, toggle, t } = useLang();
  const { count, setOpen } = useCart();
  const { user } = useAuth();
  const { count: wishCount } = useWishlist();
  const navigate = useNavigate();
  const e = ext[lang];
  const [q, setQ] = useState("");

  const submitSearch = (ev) => {
    ev.preventDefault();
    navigate(q.trim() ? `/?q=${encodeURIComponent(q.trim())}` : "/");
  };

  return (
    <header className="sticky top-0 z-40 border-b border-border bg-white" data-testid="site-header">
      <div className="flex h-[52px] items-center justify-between gap-3 px-4 sm:gap-4 sm:px-6">
        <Link to="/" data-testid="logo" className="flex items-center"><img src="/logo.png" alt="LAINER" className="h-4 w-auto sm:h-5" /></Link>

        <form onSubmit={submitSearch} className="hidden flex-1 items-center gap-2 md:flex max-w-xs">
          <Search size={13} className="opacity-50" />
          <input value={q} onChange={(ev) => setQ(ev.target.value)} placeholder={e.searchPh} data-testid="search-input"
            className="w-full bg-transparent font-mono text-[11px] uppercase tracking-widest placeholder:text-muted-foreground focus:outline-none" />
        </form>

        <div className="flex items-center gap-4">
          <Link to="/shop" className="hidden font-mono text-[11px] uppercase tracking-widest hover:opacity-60 sm:inline">{t.nav.shop}</Link>
          <button onClick={toggle} data-testid="lang-toggle" className="font-mono text-[11px] uppercase tracking-widest hover:opacity-60">{lang === "ro" ? "RO/EN" : "EN/RO"}</button>
          <Link to="/wishlist" data-testid="wishlist-link" className="flex items-center gap-1 font-mono text-[11px] uppercase tracking-widest hover:opacity-60">
            <Heart size={13} /> [{wishCount}]
          </Link>
          <Link to={user ? "/account" : "/login"} data-testid="account-link" className="flex items-center gap-1 font-mono text-[11px] uppercase tracking-widest hover:opacity-60">
            <User size={13} /><span className="hidden sm:inline">{user ? e.account : e.login}</span>
          </Link>
          <button onClick={() => setOpen(true)} data-testid="cart-button" className="font-mono text-[11px] uppercase tracking-widest hover:opacity-60">{t.nav.cart} [{count}]</button>
        </div>
      </div>
    </header>
  );
};

export default Header;
